import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const AxisBankLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. How much is the maximum loan amount available for studying abroad at Axis Bank?",
            content: "Axis Bank provides unsecured loans with a maximum loan amount of 50 Lakhs."
        },
        {
            title: "2. How long is the repayment period for an education loan from Axis Bank?",
            content: "Axis Bank offers a repayment tenure of up to 15 years, which includes the duration of the course and the grace period."
        },
        {
            title: "3. Does Axis Bank allow commercial property to be used as collateral?",
            content: "Axis Bank can consider commercial property for loans, but the loan amount will not exceed 50% of the property value."
        },
        {
            title: "4. Do education loans provide any tax benefits?",
            content: "Education loans from Axis Bank come with tax advantages under section 80(c)."
        }, {
            title: "5. Does the loan go to the borrower or the institute/college/university?",
            content: "The applicant’s living expenses are deposited into their account, while the tuition fees are sent to the university’s account. These arrangements may differ depending on different conditions."
        },
        {
            title: "6. Can I obtain a non-collateral loan from Axis Bank? Additionally, what is the minimum amount available for an education loan from Axis Bank?",
            content: "The maximum amount that can be obtained from Axis Bank for a non-collateral loan is 30 Lakhs INR."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"Axis Bank Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"Axis Bank Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Axis Bank's Loan Program for Studying Abroad</h5>
                            <p className="loan-elegibility-des">Axis Bank, formerly known as UTI Bank, was founded in 1994 and has since become the third-largest private commercial bank in India. One of the crucial services offered by Axis Bank is education loans, catering to students who aspire to pursue their studies either within India or abroad. Students can avail of secured or unsecured education loans from Axis Bank to finance their overseas education.
                                <br /><br />
                                When considering an education loan for studying abroad without the need for collateral, the maximum loan amount that can be availed is up to 50 Lakhs INR. However, if one opts for a secured education loan, where collateral is guaranteed, the loan amount can go up to 85% of the value of the collateral.
                                <br /><br />
                                Axis Bank has categorized the educational institutions into three groups according to the target university:
                                <br /><br />
                                <b>Prime A :</b> The majority of the programs listed here are Master’s programs offered by prestigious universities.
                                <br /><br />
                                <b>Prime B :</b> Apart from the various Master’s programs, there are also a limited number of bachelor’s degrees that are offered as part of the educational offerings.
                                <br /><br />
                                <b>Non-prime :</b> This category includes courses and institutes that are not listed in the Prime A or B listings.
                                <br /><br />
                                Axis Bank’s education loan not only assists students in meeting their financial needs for studying abroad but also provides them with a significant advantage in the form of a 100% tax benefit on the interest paid. This benefit is offered under Section 80(E) of the IT Act, ensuring that students can focus on their education without worrying about the financial burden.
                                <br /><br />
                                Moreover, the bank also participates in government schemes like CSIS (Central Sector Interest Subsidy Scheme), which provides additional support to economically weaker sections. With these features, Axis Bank ensures that students have access to comprehensive financial solutions that cater to their specific needs and circumstances.</p>
                            <h5 className="about-head">Benefits of Obtaining an Axis Bank Education Loan for Studying Abroad</h5>
                            <p className="loan-elegibility-des">When it comes to obtaining an unsecured education loan without the need for collateral, Axis Bank stands out as an excellent option. Pursuing your education loan abroad without collateral from Axis Bank offers numerous advantages. Especially, Axis Bank has curated a comprehensive list of overseas universities, which they have further categorized into STEM and non-STEM courses.  This classification further divides the universities into prime and non-prime categories, enabling borrowers to make informed choices. Each of these categories has a different set of features.</p>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            9.99%- 12.5%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            Prime A - upto 50 lakhs<br />
                                            Prime B- upto 40 lakhs<br />
                                            Non- Prime - On an immediate EMI basis

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest rate type</td>
                                        <td className="">

                                            Floating interest rate

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Minimum Income(Co- Applicant)</td>

                                        <td className="">35,000 INR (without obligations)</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            0.75% on sanctioned amount + GST

                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Repayment</td>
                                        <td>Need to pay S.I. only during class + 1 year grace period</td></tr>
                                    <tr>
                                        <td>Other Charges</td>
                                        <td>Nil</td>
                                    </tr>
                                </tbody>
                            </table>




                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">
                            <h5 className="about-head mb-4">Criteria for An Unsecured Axis Bank Education Loan for Study Abroad</h5>
                            <p className="loan-elegibility-des">The following requirements must be fulfilled for you to be qualified for an Axis Bank loan.</p>
                            <ol className="subhead-ul"><li>Must have achieved a minimum of 60% in both Higher Secondary and Graduation.</li>
                                <li>Both the applicant and the co-applicant must be citizens of India.</li>
                                <li>The co-applicant must have a CIBIL score higher than 600. </li>
                                <li>To be eligible, the co-applicant must possess either three years of ITR or two years of Form-16. </li>
                                <li>The co-applicant must have a salary exceeding 35,000 INR, with no additional financial commitments such as existing EMIs.</li>
                                <li>To be considered as a co-applicant, the individual must be from the immediate family. This includes the father, mother, brother, sister, or spouse.</li>
                                <li>Letter of admission for MS courses authorized by the appropriate authorities.</li>
                                <li>Applicable exclusively to master’s level programs. </li>
                                <li>Educational institutions, including universities and colleges, should be included in the bank’s list of approved institutions. </li>
                            </ol>

                            <h5 className="about-head">Required Documentation for Unsecured Axis Bank Loan for Overseas Education</h5>
                            <p className="loan-elegibility-des">At three different stages, you will encounter the need for various documents. The first set of documents will be necessary during the processing of your loan application, the second set will be required when the initial disbursement takes place, and the last set of documents will be needed for any subsequent disbursements.</p>
                            <h5 className="about-head">Documents needed in the first stage of the loan application procedure</h5>
                            <h6 className="subhead mt-4">For individuals who receive a fixed salary</h6>
                            <ol className="subhead-ul">
                                <li>Bank Statement / Pass Book of last 6 months</li>
                                <li>KYC documents</li>
                                <li>Optional – Guarantor Form</li>
                                <li>Mark sheets / passing certificates of S.S.C. (Secondary School Certificate), H.S.C (Higher Secondary School Certificate), and Degree courses.</li>
                                <li>Copy of admission letter of the Institute along with fee schedule</li>
                            </ol>
                            <h6 className="subhead">For all other Individuals:</h6>
                            <ol className="subhead-ul">
                                <li>Bank Statement / Pass Book of last 6 months</li>
                                <li>KYC documents</li>
                                <li>Copy of admission letter of the Institute along with fee schedule</li>
                                <li>Optional – Guarantor Form</li>
                                <li>Mark sheets / passing certificates of S.S.C. (Secondary School Certificate), H.S.C (Higher Secondary School Certificate), and Degree courses.</li>
                            </ol>
                            <h6 className="subhead">Necessary documents for the initial disbursement</h6>
                            <ol className="subhead-ul">
                                <li>Loan agreement signed by applicant and co-applicants</li>
                                <li>A demand letter from college or university</li>
                                <li>Disbursement request form signed by applicant and co-applicants</li>
                                <li>Sanction letter signed by applicant and co-applicants</li>
                                <li>Documents for collateral security (if applicable)</li>
                                <li>Receipts of margin money paid to the college/university along with bank statement reflecting the transaction</li>
                                <li>Form A2 signed by applicant or co-applicants in case of overseas institute</li>
                            </ol>
                            <h6 className="subhead">Documentation needed for the subsequent disbursement</h6>
                            <ol className="subhead-ul">
                                <li>A demand letter from college or university</li>
                                <li>Receipts of margin money paid to the college/university along with bank statement reflecting the transaction</li>
                                <li>Exam progress report, mark sheet, bonafide certificate (anyone)</li>
                                <li>Disbursement request form signed by applicant and co-applicants</li>
                                <li>Form A2 signed by applicant or co-applicants in case of overseas institute</li>
                            </ol>
                            <h5 className="about-head">Key Attributes of Axis Bank’s Secured Loan for Studying Abroad</h5>
                            <p className="loan-elegibility-des">Axis Bank offers not only unsecured loans but also secured loans, which require you to provide collateral to the bank. By pledging collateral, you can access the benefits of a secured loan. Additionally, when considering collateral, the co-applicants profile is taken into account. Various characteristics related to an Axis Bank secured abroad education loan include:</p>
                            <ol className="subhead-ul">
                                <li>If your co-applicant is salaried and you have pledged your residential property as collateral, you are eligible to receive up to 85% of the property value.</li>
                                <li>Up to 75% of the property value can be obtained if you have pledged a residential property as collateral and your co-applicant is self-employed.</li>
                                <li>By pledging a commercial property, you have the potential to receive up to 50% of its value.</li>
                                <li>Secured loans offer an interest rate ranging from 9.99% to 10.50%.</li>
                                <li>With a secured education loan, you are not restricted by the course or university list. This means that you have the freedom to choose any course and university, irrespective of whether they are listed in Axis Bank’s university list or not.</li>
                            </ol>

                            <h5 className="about-head">Steps to Follow When Applying for an Axis Bank Education Loan for Overseas Education</h5>
                            <p className="loan-elegibility-des">Applying for a loan with Axis Bank is a very easy procedure. All you have to do is take the steps listed below.</p>

                            <p className="loan-elegibility-des"><b>Check Loan Eligibility</b></p>

                            <p className="loan-elegibility-des"> To begin, you need to assess your loan eligibility with Credere. This involves providing certain information such as personal details, the university you are aiming for, the amount of loan you require, and other relevant details.</p>



                            <p className="loan-elegibility-des"><b>Loan Processing</b></p>

                            <p className="loan-elegibility-des">  Once your loan eligibility has been verified, a dedicated education loan counselor (ELC) from Credere will reach out to you. They will assist you in preparing a customized document checklist. At the same time, the ELC will work on submitting your details to Axis Bank. </p>

                            <p className="loan-elegibility-des"><b>Convenient Document Collection at Your Doorstep</b></p>

                            <p className="loan-elegibility-des">  After you have organized all the necessary documents, a representative from Axis Bank, known as a relationship officer (RO), will come to collect and authenticate them. In case any documents are found to be missing, both Credere’s ELC and Axis Bank’s RO will inform you within 24 hours.</p>

                            <p className="loan-elegibility-des"><b>Loan Approval and Sanction</b></p>

                            <p className="loan-elegibility-des">  After the verification process is complete, the applicant will receive an email notifying them of the loan approval. This email will include specific details about the approved loan amount and other important information. To proceed with the loan sanctioning, the applicant will need to sign the email as confirmation. </p>
                            <h5 className="about-head mb-4">Advantages of Getting Axis Bank Abroad Education Loan from Credere</h5>
                            <p className="loan-elegibility-des">You would have several advantages if you proceeded with your Axis Bank loan through Credere. The following is a list of a few benefits:</p>
                            <p className="loan-elegibility-des"><b>Guaranteed Best Loan</b></p>

                            <p className="loan-elegibility-des">    Credere is dedicated to offering the best education loan accessible to you. We guarantee that our team will work hard to find you the most advantageous deal. If you happen to find a more attractive deal, we will make up for the difference in interest rates for the entire duration of your education loan.</p>

                            <p className="loan-elegibility-des"><b>Higher Chances of Approval</b></p>

                            <p className="loan-elegibility-des">  Credere makes sure that your application is only sent to Axis Bank once you have satisfied all qualifying conditions.</p>

                            <p className="loan-elegibility-des"><b>Personalized Documents Checklist</b></p>

                            <p className="loan-elegibility-des">  Credere offers a customized list of necessary documents, along with other options, to facilitate the submission of paperwork speedily.</p>

                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>

                            <p className="loan-elegibility-des">  Credere can process loans in 5-7 days after receiving documents, while Axis Bank takes 15 days for direct applicants.</p>

                            <p className="loan-elegibility-des"><b>Completely Free Services</b></p>

                            <p className="loan-elegibility-des">  Throughout the process, Credere offers the support of an education loan counselor without any additional fees.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default AxisBankLendingPartner;